import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";
import { setLoading } from "../loading/loadingSlice";

const BASE_URL = "/api/v1/hospital/appointments";

export const fetchWaivedOffAppointments = createAsyncThunk(
  "appointments/fetchWaivedOff",
  async ({ page = 1, limit = 10 }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setLoading(true));
      const response = await api.get(`${BASE_URL}/waived_off`, {
        params: { page, limit }  // send pagination params as query strings
      });
      return response.data;
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || "Error fetching waived off appointments";
      return rejectWithValue(message);
    } finally {
      dispatch(setLoading(false));
    }
  }
);


export const waiveOffAppointment = createAsyncThunk(
  "appointments/waiveOff",
  async ({ appointmentId, waiveOffReason }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setLoading(true));
      const response = await api.post(`${BASE_URL}/waive_off/${appointmentId}`, { waiveOffReason });
      return response.data;
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || "Error waiving off appointment";
      return rejectWithValue(message);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
